import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { getProposalByKey, getLogoByCompany } from '../../actions/ProposalsSign';
import MainLogo from '../../Res/epik-main-page.png';
import EpikLogo from '../../Res/Epik-Logo-Color.png';
import './LoaDocuments.css';

const MainPage = (props) => {
  const [agencyName, setAgencyName] = useState(undefined);
  const [agencyLogo, setAgencyLogo] = useState(undefined);

  useEffect(() => {
    (async function () {
      const { getProposalByKey, getLogoByCompany } = props;
      const path = window.location.pathname.split('/');
      let proposalUuid = path[path.length - 2];

      const token = localStorage.getItem('jwtToken');

      const res = await getProposalByKey(proposalUuid);
      if (res) {
        const img = await getLogoByCompany(token, res.meta.company._id);
        if (img) {
          setAgencyLogo(img);
        }
        setAgencyName(res.meta.company.name);
      }
    })();
  }, []);
  return (
    <div className="loa-doc-wrapper">
      <div className="loa-doc-page">
        <div className="main-doc-page">
          <img src={MainLogo} className="main-page-logo" />
          <span className="main-page-agency-name">Presented by {agencyName || ''}</span>
          <img src={agencyLogo || EpikLogo} className="main-page-agency-logo" />
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = dispatch => ({
  getProposalByKey: uuid => dispatch(getProposalByKey(uuid)),
  getLogoByCompany: (token, cid) => dispatch(getLogoByCompany(token, cid))
});

export default connect(null, mapDispatchToProps)(MainPage);
